module.exports = __webpack_public_path__ + "assets/img-error.c0a0161e.svg";